// IE 2026 09 20 / ODOO-… (находка 19.09: переключение группы строк у «Orders by documents» — 3,6 с, из них 2,3 с — проверка «строка пуста»):
// чистая логика быстрой проверки пустоты строки грида. Прежний цикл AttrGrid.isEmpty на КАЖДУЮ колонку звал два действия стора
// (store.get_value + store.isEmpty — каждое через обёртку действий Pinia) и читал определение колонки через реактивный прокси:
// строка отчёта со 192 колонками — ~1,6 мс. Здесь колонки один раз за проход складываются в ПЛАН (плоские сырые описания с уже
// разобранным путём), а строка читается напрямую из сырого объекта. Правила — те же, что у AttrGrid.isEmpty / mainStore.get_value /
// mainStore.isEmpty (юнит-тест сверяет с эталонным циклом на случайных данных). Выключатель — fastEntry.rowEmptyPlan.

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
const EMPTY_DATE = '0001-01-01T00:00:00'

// то же, что mainStore.isEmpty(value)
export function rowEmpty_valueEmpty(value) {
    return (
        value === null ||
        value === undefined ||
        value === 0 ||
        value === '0' ||
        value === false ||
        value === '' ||
        value === EMPTY_GUID ||
        value === EMPTY_DATE ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
    )
}

// то же, что mainStore._parse_binding(binding): 'a.b[2].c' → ['a', ['b', 2], 'c']; не строка / пусто → []
export function rowEmpty_parse(binding) {
    if (typeof binding !== 'string' || binding.length === 0) return []
    const path = binding.split('.').map(s => s.trim())
    if (binding.indexOf('[') !== -1) {
        for (let i = 0; i < path.length; i++) {
            const match = path[i].match(/^(.+?)\[(\d+)\]$/)
            if (match) path[i] = [match[1], parseInt(match[2], 10)]
        }
    }
    return path
}

// то же, что mainStore.get_value(record, binding) с default_ = null и без row / col: ключ целиком (в т.ч. с точками) → иначе путь
export function rowEmpty_value(record, binding, path) {
    if (record === null) return null
    if (binding in record) return record[binding]
    let value = record
    for (let i = 0; i < path.length; i++) {
        const seg = path[i]
        if (value === null || typeof value !== 'object') return null
        if (Array.isArray(seg)) {
            const key = seg[0], index = seg[1]
            if (key in value && Array.isArray(value[key]) && value[key].length > index) value = value[key][index]
            else return null
        } else if (seg in value) {
            value = value[seg]
        } else {
            return null
        }
    }
    return value
}

// План колонок. opts: { ignoreUse — attr.nonEmpty_ignore_use грида; dataGrid — грид данных отчёта / списка (attr.binding == '_doc.data':
// пустоту судят только ресурсы AttrNumber / AttrTime); parse — разбор пути (в гриде — store._parse_binding, общий кэш путей) }
// Узел: { b, path, skip — колонка use при ignoreUse, data — значение колонки участвует в проверке, sub — план вложенных колонок }
export function rowEmpty_buildPlan(attrs, opts) {
    const parse = opts?.parse || rowEmpty_parse
    const plan = []
    for (const a of attrs || []) {
        if (!a || typeof a !== 'object') continue
        const type = a.attr_type, b = a.binding
        plan.push({
            b,
            path: parse(b),
            skip: !!opts?.ignoreUse && b === 'use',
            data: type === 'AttrNumber' || type === 'AttrTime' || !opts?.dataGrid,
            sub: (Array.isArray(a.attrs) && type !== 'AttrGrid') ? rowEmpty_buildPlan(a.attrs, opts) : null,
        })
    }
    return plan
}

// строка пуста по плану: ни одна колонка-ресурс (и ни одна вложенная) не несёт значения. raw — СЫРОЙ объект строки (toRaw)
export function rowEmpty_byPlan(raw, plan) {
    for (let i = 0; i < plan.length; i++) {
        const n = plan[i]
        if (n.skip) continue
        if (n.data && !rowEmpty_valueEmpty(rowEmpty_value(raw, n.b, n.path))) return false
        if (n.sub && !rowEmpty_byPlan(raw, n.sub)) return false
    }
    return true
}
